document.addEventListener("DOMContentLoaded", function () {
  const showModalLinks = document.querySelectorAll('[data-type="dialog-opener"]');
  const dialog = document.querySelector("dialog");

  if (!dialog) { return };

  showModalLinks.forEach(link => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      dialog.showModal();
    });
  });
});
